export const PRIMARY = '#6EB23F';
export const PRIMARY_FINAL = '#5E9732';

export const BACKGROUND_TABLE_HEADER = '#D5EBC6';
export const BACKGROUND_TABLE_GROUP = '#E2F0D8';
export const BACKGROUND_HOVER = '#f9f9f9';
export const BACKGROUND_WHITE = '#ffffff';

export const NEUTRAL = '#CCCCCC';
export const NEUTRAL_DARK = '#909090';
export const NEUTRAL_LIGHT = '#DDDDDD';

export const CHART_POSITIVE = PRIMARY;
export const CHART_NEGATIVE = '#FF0033';
export const CHART_HISTORICAL = NEUTRAL_LIGHT;

export const TEXT_PRIMARY = '#333333';
